import { createApp } from 'vue'
import Alert from '~/components/core/notification/Alert.vue'

export type AlertProps = {
   title: string
   description?: string
   type: 'confirm' | 'loading'
   confirmLabel?: string
   discardLabel?: string
}

let currentAlert: { app: ReturnType<typeof createApp>; div: HTMLElement; vm: any } | null = null

function cleanup() {
   if (currentAlert) {
      currentAlert.app.unmount()
      document.body.removeChild(currentAlert.div)
      currentAlert = null
   }
}

export default defineNuxtPlugin(() => {
   return {
      provide: {
         alert: {
            show: (props: AlertProps): Promise<boolean> => {
               return new Promise((resolve) => {
                  cleanup()

                  const alertDiv = document.createElement('div')
                  document.body.appendChild(alertDiv)

                  const app = createApp(Alert, {
                     ...props,
                     onConfirm: () => resolve(true),
                     onCancel: () => resolve(false),
                     'onAfter-leave': () => cleanup(),
                  })

                  const vm = app.mount(alertDiv)
                  currentAlert = { app, div: alertDiv, vm }
               })
            },
            hide: () => {
               if (currentAlert) {
                  currentAlert.vm.dismiss()
               }
            },
         },
      },
   }
})
